// ts-unused-exports:disable-next-line
export const fcBookingEngineSuggest = (): SuggestObject => {
    let elem: HTMLInputElement;
    let searchValue: string;
    let locale = 'de-ch';
    let lang = 'de';

    const o: SuggestOptions = {
        searchUrl: 'https://ferien.kuoni.ch/api/keywords?',
        bookingType: 'PACKAGE',
        whiteLabel: '',
        minLength: 3
    };
    const labels: Labels = {
        de: {
            destinations: 'Reiseziele',
            accommodations: 'Hotels'
        },
        fr: {
            destinations: 'Destinations',
            accommodations: 'Hôtels'
        }
    };

    const setLocale = (): void => {
        const [html] = document.getElementsByTagName('html');
        if (html) {
            const langAttrib = html.getAttribute('lang');
            if (langAttrib) {
                locale = langAttrib.toLowerCase();
                lang = langAttrib.substring(0, 2).toLowerCase();
            }
        }
    };

    const isVisible = (element: HTMLElement, container:HTMLElement): boolean => {
        return ((element.offsetTop + element.clientHeight) < (container.clientHeight + container.scrollTop) && element.offsetTop >= container.scrollTop);
    };

    const showSuggestions = (data: SuggestResults): void => {
        if (!elem) {
            return;
        }

        const destinationSuggestions:DestinationSuggestResult[] = [];
        const hotelSuggestions:AccommodationSuggestResult[] = [];
        const suggestionsList:Array<SuggestHeader | DestinationSuggestResult | AccommodationSuggestResult> = [];

        data.matches.forEach((element) => {
            switch (element.type) {
                case 'Destination':
                    destinationSuggestions.push(element);
                    break;
                case 'Accommodation':
                    hotelSuggestions.push(element);
                    break;
            }
        });

        if (destinationSuggestions.length > 0) {
            suggestionsList.push({
                type: 'GroupHeader',
                name: labels[lang].destinations
            });
            suggestionsList.push(...destinationSuggestions);
        }

        if (hotelSuggestions.length > 0) {
            suggestionsList.push({
                type: 'GroupHeader',
                name: labels[lang].accommodations
            });
            suggestionsList.push(...hotelSuggestions);
        }

        if (suggestionsList.length === 0) {
            return;
        }

        const inputFieldParent = elem.parentElement;
        if (inputFieldParent === null) {
            return;
        }

        let [layerDiv] = <HTMLCollectionOf<HTMLDivElement>>inputFieldParent.getElementsByClassName('search-suggestions');
        if (!layerDiv) {
            layerDiv = document.createElement('div');
            layerDiv.className = 'search-suggestions';
            layerDiv.id = `${elem.id}-list`;
            inputFieldParent.appendChild(layerDiv);
            elem.setAttribute('aria-controls', `${elem.id}-list`);
        } else {
            layerDiv.innerHTML = '';
        }
        const suggestListElem = document.createElement('ul');
        suggestListElem.className = 'suggest-results';
        suggestListElem.setAttribute('role', 'listbox');
        layerDiv.appendChild(suggestListElem);

        suggestionsList.forEach((element, index) => {
            let elem: HTMLLIElement;
            let elemLink: HTMLAnchorElement;

            if (element.type === 'GroupHeader') {
                elem = document.createElement('li');
                elem.className = 'suggest-group-header';
                elem.textContent = <string>element.name;
                suggestListElem.appendChild(elem);
            } else if (element.type === 'Destination') {
                elem = document.createElement('li');
                elem.className = 'suggest-item suggest-destination';
                elem.setAttribute('role', 'option');
                elem.ariaPosInSet = `${index + 1}`;
                elem.ariaSetSize = `${suggestionsList.length}`;
                elem.tabIndex = -1;
                elemLink = document.createElement('a');
                elemLink.setAttribute('data-type', 'destination');
                elemLink.setAttribute('data-nodes', <string>element.code);
                elemLink.textContent = <string>element.name;
                elem.appendChild(elemLink);
                suggestListElem.appendChild(elem);
            } else if (element.type === 'Accommodation') {
                const accomElement = <AccommodationSuggestResult>element;
                elem = document.createElement('li');
                elem.className = 'suggest-item suggest-accommodation';
                elem.setAttribute('role', 'option');
                elem.ariaPosInSet = `${index + 1}`;
                elem.ariaSetSize = `${suggestionsList.length}`;
                elem.tabIndex = -1;
                elemLink = document.createElement('a');
                elemLink.setAttribute('data-type', 'accommodation');
                elemLink.setAttribute('data-code', <string>element.code);
                elemLink.innerHTML = <string>element.name;
                if (accomElement.location.country.name === accomElement.location.region.name) {
                    elemLink.innerHTML += `<span class="location">${accomElement.location.country.name}</span>`;
                } else {
                    elemLink.innerHTML += `<span class="location">${accomElement.location.country.name}, ${accomElement.location.region.name}</span>`;
                }
                elem.appendChild(elemLink);
                suggestListElem.appendChild(elem);
            }
        });

        if (suggestionsList.length) {
            suggestListElem.addEventListener('click', (e) => {
                const target = <HTMLElement>e.target;
                if (target.tagName === 'A') {
                    elem.value = <string>target.textContent;
                    const formName = elem.getAttribute('data-formname');
                    target.classList.add('focus');
                    const dataType = target.getAttribute('data-type');
                    if (elem.parentElement && formName) {
                        const destField = <HTMLInputElement>elem.parentElement.querySelector(`#knfastbooking_dest_${formName}`);
                        const aidField = <HTMLInputElement>elem.parentElement.querySelector(`#knfastbooking_aid_${formName}`);
                        let dataValue = null;
                        switch (dataType) {
                            case 'destination':
                                dataValue = target.getAttribute('data-nodes');
                                if (elem.parentElement) {
                                    if (aidField && dataValue) {
                                        aidField.value = '';
                                        destField.value = dataValue;

                                        layerDiv.innerHTML = '';
                                    }
                                }
                                break;
                            case 'accommodation':
                                dataValue = target.getAttribute('data-code');
                                if (elem.parentElement) {
                                    if (aidField && dataValue) {
                                        aidField.value = dataValue;
                                        destField.value = '';

                                        layerDiv.innerHTML = '';
                                    }
                                }
                                break;
                        }
                    }
                }
            });

            layerDiv.style.display = 'block';
            elem.setAttribute('aria-expanded', 'true');
        }
    };

    const handleSuggest = (value: string): boolean => {
        // latest search value
        searchValue = value;

        // build API request uri
        const uri = `${o.searchUrl}locale=${locale}&bookingType=${o.bookingType}&whitelabel=${o.whiteLabel}&query=${value}`;
        // fetch
        fetch(uri)
            .then((response) => {
                return response.json();
            })
            .then((data: SuggestResults) => {
                if (searchValue !== value) {
                    return false;
                }
                if (data.matches.length > 0) {
                    showSuggestions(data);
                } else {
                    const inputFieldParent = elem.parentElement;
                    if (inputFieldParent !== null) {
                        const [layerDiv] = <HTMLCollectionOf<HTMLDivElement>>inputFieldParent.getElementsByClassName('search-suggestions');
                        if (layerDiv) {
                            layerDiv.innerHTML = '';
                        }
                    }
                }
                return true;
            })
            .catch((err) => {
                console.log(err);
            });

        return true;
    };

    const init = (element: HTMLElement, options?: SuggestOptions): void => {
        elem = <HTMLInputElement>element;

        if (options) {
            Object.assign(o, options);
        }

        const bookingTypeByAttribute = elem.getAttribute('data-btype');
        if (bookingTypeByAttribute) {
            o.bookingType = bookingTypeByAttribute;
        }

        setLocale();

        elem.addEventListener('input', () => {
            if (elem.value.length < o.minLength) {
                return;
            }
            handleSuggest(elem.value);
        });

        elem.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') {
                return;
            }

            const listContainer = <HTMLElement>document.querySelector(`#${elem.id}-list>ul`);
            const listElements = [...document.querySelectorAll(`#${elem.id}-list>ul>li>a`)];
            const listElementsCount = listElements.length - 1;
            const focusedListElem = document.querySelector(`#${elem.id}-list>ul>li>a.focus`);

            let elemToFocus = null;
            e.preventDefault();
            if (focusedListElem) {
                const focusIndex = listElements.indexOf(focusedListElem);
                if (e.key === 'ArrowUp') {
                    elemToFocus = <HTMLElement>listElements[focusIndex > 0 ? focusIndex - 1 : 0];
                    focusedListElem.classList.remove('focus');
                    elemToFocus.classList.add('focus');
                    if (listContainer && !isVisible(elemToFocus, listContainer)) {
                        listContainer.scroll({ top: elemToFocus.offsetTop - Math.floor(listContainer.clientHeight / 3) });
                    }
                }
                if (e.key === 'ArrowDown') {
                    elemToFocus = <HTMLElement>listElements[focusIndex < listElementsCount ? focusIndex + 1 : listElementsCount];
                    focusedListElem.classList.remove('focus');
                    elemToFocus.classList.add('focus');
                    if (listContainer && !isVisible(elemToFocus, listContainer)) {
                        listContainer.scroll({ top: elemToFocus.offsetTop - Math.floor(listContainer.clientHeight / 3) });
                    }
                }
            } else {
                if (e.key === 'ArrowDown') {
                    elemToFocus = <HTMLElement>listElements[0];
                    elemToFocus.classList.add('focus');
                }
            }
        });

        elem.addEventListener('focus', () => {
            if (elem.parentElement) {
                elem.select();
                const [layerDiv] = <HTMLCollectionOf<HTMLDivElement>>elem.parentElement.getElementsByClassName('search-suggestions');
                if (layerDiv && layerDiv.innerHTML !== '') {
                    layerDiv.style.display = 'block';
                }
            }
        });

        document.addEventListener('click', (e) => {
            if (elem.parentElement) {
                if (!elem.parentElement.contains(<Node>e.target)) {
                    const [layerDiv] = <HTMLCollectionOf<HTMLDivElement>>elem.parentElement.getElementsByClassName('search-suggestions');
                    if (layerDiv) {
                        layerDiv.style.display = 'none';
                        elem.setAttribute('aria-expanded', 'false');
                    }
                }
            }
        });
    };

    return {
        init
    };
};
